import { createFileRoute } from '@tanstack/react-router'
import { AlertRulesPage } from '../../../features/alerts/AlertRulesPage'

/* ───── Route Definition ───── */

export const Route = createFileRoute('/_authenticated/alerts/')({
  component: AlertRulesPage,
})
